import type {
  AuthResponse,
  GuestLoginPayload,
  LoginCredentials,
  RegisterPayload,
  UserProfile,
} from '@matchroom/shared';
import { API_ROUTES } from '@matchroom/shared';
import { apiClient } from '@/lib/api-client';

export const authService = {
  register: (payload: RegisterPayload) =>
    apiClient.post<AuthResponse>(API_ROUTES.AUTH.REGISTER, payload),

  login: (payload: LoginCredentials) =>
    apiClient.post<AuthResponse>(API_ROUTES.AUTH.LOGIN, payload),

  guestLogin: (payload: GuestLoginPayload) =>
    apiClient.post<AuthResponse>(API_ROUTES.AUTH.GUEST, payload),

  logout: () => apiClient.post<{ message: string }>(API_ROUTES.AUTH.LOGOUT),

  refresh: () =>
    apiClient.post<{ tokens: { accessToken: string; expiresIn: number } }>(API_ROUTES.AUTH.REFRESH),

  me: () => apiClient.get<{ user: UserProfile }>(API_ROUTES.AUTH.ME),
};
